import type { NavigationBarItem } from "@app/components/AppScaffold.tsx";
import { trpc } from "@app/trpc.ts";
import type { UserAccessRole } from "@server/models.ts";
import { useQuery } from "@tanstack/react-query";
import { BarChart3, Package, Users } from "lucide-react";

export function useNavigationItems({ enabled }: { enabled: boolean }) {
  const { data } = useQuery({
    ...trpc.users.role.queryOptions(),
    enabled,
  });
  return data ? itemsMap[data] : [];
}

const enterpriseTab: NavigationBarItem = {
  label: "Empresa",
  to: "/enterprises/overview",
  icon: BarChart3,
  activePathnamePrefixes: ["/enterprises", "/stores"],
};
const erpTab: NavigationBarItem = {
  label: "Estoque",
  to: "/erp",
  icon: Package,
  activePathnamePrefixes: ["/erp"],
};
const peopleTab: NavigationBarItem = {
  label: "Pessoas",
  to: "/employees",
  icon: Users,
  activePathnamePrefixes: ["/employees", "/early-payments", "/reimbursements"],
};

const itemsMap: Record<UserAccessRole, NavigationBarItem[]> = {
  admin: [enterpriseTab, peopleTab, erpTab],
  enterpriseOwner: [enterpriseTab, peopleTab, erpTab],
  storeManager: [enterpriseTab, peopleTab, erpTab],
  auth: [],
};
